export const environment = {
  production: true,
  buildId: '2817859431419371',
  configFile: 'config.json',
};
